import React, { useState, useEffect, useRef } from 'react'
import DeckGL from '@deck.gl/react'
import { GeoJsonLayer, IconLayer } from '@deck.gl/layers'
import { StaticMap } from 'react-map-gl'
import { TripsLayer } from '@deck.gl/geo-layers'
import { ViewMode } from 'nebula.gl'
import { parse, stringify } from 'wellknown'
import * as turf from '@turf/turf'
import '../static/css/style.css'
import { Loader } from 'react-loaders'
import { useParams } from 'react-router-dom'

function Map (props) {
  let { long, lat, hash } = useParams()

  const initialViewState = {
    longitude: +long,
    latitude: +lat,
    zoom: window.innerWidth < 800 ? 12 : 13
  }

  const point = {
    type: 'FeatureCollection',
    features: [
      { 'type': 'Feature',
        'geometry': { 'type': 'Point', 'coordinates': [0, 0] },
        'properties': { 'contour': 30 }
      }
    ]
  }

  const [waze, setWaze] = useState()
  const [stamp, setStamp] = useState(0)

  const [selected, setSelected] = useState(point)
  const [mode, setMode] = useState({ 'mode': ViewMode })
  const [isos, setIsos] = useState(point)
  const [rendered, setRendered] = useState(false)

  const step = () => {
    requestAnimationFrame(step)
    setStamp(function (prevStamp) {
      let currStamp = prevStamp + 100
      return currStamp % 200000
    })
  }

  useEffect(() => {
    step()
  }, [])

  useEffect(() => {
    if (!long) {
      return
    }
    if (!lat) {
      return
    }
    setSelected({
      'type': 'FeatureCollection',
      'features': [{
        'geometry': {
          'type': 'Point',
          'coordinates': [+long, +lat]
        }
      }]
    })

    getIsos([long, lat])
  }, [long, lat])

  const getIsos = (data) => {
    setWaze('loading')

    const url = 'https://api.mapbox.com/isochrone/v1/mapbox/walking/' + data[0] + ',' + data[1] + '?contours_minutes=5,15,30&polygons=true&access_token=pk.eyJ1IjoidGhpbmtkYXRhc2NpIiwiYSI6ImNqbGhrMXNkMDFqNmYza3BhNHZtbDdzbnEifQ.XZF72CZ-zTaY6mLLwEcE2A'

    fetch(url).then(res => res.json()).then((result) => {
      setIsos(result)
    })
  }

  useEffect(() => {
    if (isos === point) {
      return
    }
    let poly = stringify(isos.features.filter(k => k.properties.contour == 30)[0].geometry)

    let url = new URL('https://us-central1-tm-geospatial.cloudfunctions.net/getTraffic')
    let params = { 'poly': poly }
    Object.keys(params).forEach(key => url.searchParams.append(key, params[key]))

    fetch(url.href).then(res => res.json()).then((result) => {
      let allJams = []
      const isoPoly = turf.polygon(isos.features[0].geometry.coordinates)

      result['traffic'].forEach(function (k) {
        let currJam = []
        let i = 1
        let geom = parse(k.geometry)
        let coordTime = 1800 / geom.coordinates.length
        geom.coordinates.forEach(function (c) {
          let isoPoint = turf.point(c)
          if (turf.booleanPointInPolygon(isoPoint, isoPoly)) {
            currJam.push({ 'coordinates': c, 'timestamp': k.properties.startTime + i * coordTime })
            i += 1
          }
        })

        allJams.push({
          'waypoints': currJam,
          'properties': k.properties
        })
      })

      setWaze(allJams)
    })
  }, [isos])

  useEffect(() => {
    setStamp(0)
    if (waze === 'loading') {
      props.handleLoading(true)
    } else {
      props.handleLoading(false)
    }
  }, [waze])

  return (
    <div className='card-map' >
      <div>
        <DeckGL
          initialViewState={initialViewState}
        >

          <StaticMap
            mapboxApiAccessToken={'pk.eyJ1IjoidGhpbmtkYXRhc2NpIiwiYSI6ImNqbGhrMXNkMDFqNmYza3BhNHZtbDdzbnEifQ.XZF72CZ-zTaY6mLLwEcE2A'}
            mapStyle='mapbox://styles/thinkdatasci/ck3o6m6bj16z21cn7jj78371g'
            {...props}
          />

          <GeoJsonLayer
            id='iso-layer'
            data={isos}
            getFillColor={d => props.isoColors[d.properties.contour]}
            getLineColor={[0, 0, 0, 0]}
            opacity={0.3}
          />

          <TripsLayer
            id='trips-layer'
            data={waze === 'loading' ? point : waze}
            getPath={d => d.waypoints.map(p => p.coordinates)}
            getTimestamps={d => d.waypoints.map(p => p.timestamp - 1545350400)}
            getColor={d => props.levelColors[d.properties.level]}
            opacity={0.5}
            widthMinPixels={5}
            rounded
            trailLength={2000}
            currentTime={stamp}
            // {...time}
          />

          <IconLayer
            id='geojson-layer'
            data={[{
              'coordinates': [+long, +lat, 500],
              // 'url': 'https://storage.googleapis.com/magtanggol-github-io/christmais-icons/iso-icon.png'
              'url': require('../static/imgs/iso-icon.png')
            }]}
            getIcon={d => ({
              url: d.url,
              width: 128,
              height: 128
            })}
            getPosition={d => d.coordinates}
            sizeScale={20}
            // getSize={d => 5}
            sizeMinPixels={40}
            opacity={1}
          />

        </DeckGL>

      </div>
      <Loader type='line-scale' active />
    </div>
  )
}

export default Map
